
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.13.0
 * Query Engine version: efdf9b1183dddfd4258cd181a72125755215ab7b
 */
Prisma.prismaVersion = {
  client: "3.13.0",
  engine: "efdf9b1183dddfd4258cd181a72125755215ab7b"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.AccountScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  oauth_token_secret: 'oauth_token_secret',
  oauth_token: 'oauth_token'
});

exports.Prisma.SessionScalarFieldEnum = makeEnum({
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  role: 'role'
});

exports.Prisma.VerificationTokenScalarFieldEnum = makeEnum({
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
});

exports.Prisma.OrganizationScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  userId: 'userId',
  createdAt: 'createdAt'
});

exports.Prisma.AttendeeScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt'
});

exports.Prisma.TeamScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  adminId: 'adminId',
  image: 'image',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.EventTeamScalarFieldEnum = makeEnum({
  id: 'id',
  teamId: 'teamId',
  eventId: 'eventId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.EventScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  description: 'description',
  banner: 'banner',
  ownerId: 'ownerId',
  quizId: 'quizId',
  startDate: 'startDate',
  location: 'location',
  teamCount: 'teamCount',
  price: 'price',
  currency: 'currency',
  createdAt: 'createdAt'
});

exports.Prisma.QuizScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  description: 'description',
  thumbnail: 'thumbnail',
  ownerId: 'ownerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.QuestionScalarFieldEnum = makeEnum({
  id: 'id',
  ownerId: 'ownerId',
  questionModeId: 'questionModeId',
  isGlobal: 'isGlobal',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.QuestionContentScalarFieldEnum = makeEnum({
  id: 'id',
  questionId: 'questionId',
  type: 'type',
  content: 'content'
});

exports.Prisma.QuestionCategoryScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  color: 'color'
});

exports.Prisma.AnswerScalarFieldEnum = makeEnum({
  id: 'id',
  questionId: 'questionId',
  answer: 'answer'
});

exports.Prisma.QuestionModeScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  description: 'description'
});

exports.Prisma.QuestionScoringModeScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  description: 'description'
});

exports.Prisma.QuizQuestionScalarFieldEnum = makeEnum({
  id: 'id',
  quizId: 'quizId',
  questionId: 'questionId',
  quizSlideId: 'quizSlideId',
  scoringModeId: 'scoringModeId'
});

exports.Prisma.QuizSlideScalarFieldEnum = makeEnum({
  id: 'id',
  quizId: 'quizId',
  ordinal: 'ordinal',
  backgroundColor: 'backgroundColor'
});

exports.Prisma.QuizSlideElementScalarFieldEnum = makeEnum({
  id: 'id',
  quizSlideId: 'quizSlideId',
  questionContentId: 'questionContentId'
});

exports.Prisma.PointScalarFieldEnum = makeEnum({
  id: 'id',
  quizSlideElementId: 'quizSlideElementId',
  width: 'width',
  height: 'height',
  x: 'x',
  y: 'y',
  z: 'z'
});

exports.Prisma.EventTeamAnswerScalarFieldEnum = makeEnum({
  eventTeamId: 'eventTeamId',
  questionId: 'questionId',
  answer: 'answer',
  status: 'status',
  points: 'points',
  createdAt: 'createdAt',
  submittedAt: 'submittedAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});
exports.Role = makeEnum({
  ADMIN: 'ADMIN',
  ORGANIZATION: 'ORGANIZATION',
  ATTENDEE: 'ATTENDEE'
});

exports.Currency = makeEnum({
  USD: 'USD',
  EUR: 'EUR'
});

exports.QuestionElementType = makeEnum({
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO'
});

exports.EventAnswerStatus = makeEnum({
  UNANSWERED: 'UNANSWERED',
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT'
});

exports.Prisma.ModelName = makeEnum({
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  VerificationToken: 'VerificationToken',
  Organization: 'Organization',
  Attendee: 'Attendee',
  Team: 'Team',
  EventTeam: 'EventTeam',
  Event: 'Event',
  Quiz: 'Quiz',
  Question: 'Question',
  QuestionContent: 'QuestionContent',
  QuestionCategory: 'QuestionCategory',
  Answer: 'Answer',
  QuestionMode: 'QuestionMode',
  QuestionScoringMode: 'QuestionScoringMode',
  QuizQuestion: 'QuizQuestion',
  QuizSlide: 'QuizSlide',
  QuizSlideElement: 'QuizSlideElement',
  Point: 'Point',
  EventTeamAnswer: 'EventTeamAnswer'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
